import "babel-polyfill"
// First load isomorphic-relay:
import IsomorphicRelay from "isomorphic-relay"
// And only then load react-relay:
import initRelay from "./relay"

import IsomorphicRouter from "isomorphic-relay-router"
import React from "react"
import ReactDOM from "react-dom"

import { dispatch } from "./Dispatcher"
import auth from "./auth"
import { setToken, loadPreferences } from "./actions"

import { isomorphicVars } from "./scripts/isomorphicVars"

//Adds a class to body e.g. mouse to sepecify the input type
import "what-input"

import { windowSizeListen } from "./scripts/size"
windowSizeListen()

import "./styles/style.scss"

import { browserHistory } from "react-router"
import { addBodyClassListener } from "./bodyClasses"
import { analyticsListen } from "./analyticsAndSocial"

import routes from "./routes"

//Needed for onTouchTap
//Can go away when react 1.0 release
//Check this repo:
//https://github.com/zilverline/react-tap-event-plugin
import injectTapEventPlugin from "react-tap-event-plugin"
import { translationMessages } from "./i18n"
import { LanguageProvider } from "./components/LanguageProvider"
import { getPrefs } from "./scripts/prefs"
import ErrorBoundary from "./components/ErrorBoundary";

injectTapEventPlugin()

dispatch(setToken(auth.getAccessToken()))
dispatch(loadPreferences(getPrefs()))

// Retrieve prepared data
const data = JSON.parse(document.getElementById("preloadedData").textContent)

initRelay()

// Pass prepared data to relay
IsomorphicRelay.injectPreparedData(data)

addBodyClassListener()

var doc = document.documentElement
doc.setAttribute("data-useragent", navigator.userAgent)

const render = messages => {
  if (typeof window !== "undefined" && window.Sentry) {
    window.Sentry.init = () => ({
      tracesSampleRate: 1.0,
    })
  }

  Object.keys(messages).forEach(langCode => {
    messages[langCode]["settings.authentic-account-id"] = String(
      window.accountSettings.authentic_account_id
    )
  })

  ReactDOM.render(
    <ErrorBoundary>
      <LanguageProvider messages={messages}>
        <IsomorphicRouter.Router routes={routes} history={browserHistory} />
      </LanguageProvider>
    </ErrorBoundary>,
    document.getElementById("root")
  )
}

render(translationMessages)

analyticsListen(window.accountSettings.authentic_account_id)



// WEBPACK FOOTER //
// ./webapp/app.js